import React, { useContext, useState } from "react";
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { Settings, Person, Logout, AdminPanelSettings } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import classNames from "classnames";

import "./HeaderStyles.css";
import { UserContext } from "../../context/UserContext";
import RoleImpersonation from "./RoleImpersonation";
import ROLES from "../../util/roles";
import { checkRole } from "../../util/FormUtils";
import { version } from "../../util/Version";

const Header = () => {
    const { user, logout } = useContext(UserContext);
    const [shortcutMenu, setShortcutMenu] = useState(null);
    const [profileMenu, setProfileMenu] = useState(null);

    return (
        <AppBar position="sticky" elevation={0} className="appBar">
            <Toolbar className="toolbar">
                <a href="/xplans" className="xplansLogoLink">
                    <h1 className="xplansLogo">
                        <span>EXPERIMENTAL</span>
                        <span>
                            <span>PLANS </span>
                            <span className="versionNumber">{version}</span>
                        </span>
                    </h1>
                </a>
                <div className="grow" />

                <IconButton
                    aria-haspopup="true"
                    color="inherit"
                    aria-controls="shortcut-menu"
                    onClick={(e) => setShortcutMenu(e.currentTarget)}
                    sx={{ marginRight: "1em" }}
                >
                    <MenuIcon className="headerIcon" />
                </IconButton>
                <Menu
                    id="profile-menu"
                    open={Boolean(shortcutMenu)}
                    anchorEl={shortcutMenu}
                    onClose={() => setShortcutMenu(null)}
                    className="headerMenu"
                    classes={{ paper: "profileMenu" }}
                    disableAutoFocusItem
                >
                    <MenuItem
                        className={classNames("profileMenuItem", "headerMenuItem")}
                        onClick={() => (window.location = "/xplans")}
                    >
                        Experimental Plans
                    </MenuItem>
                    <MenuItem
                        className={classNames("profileMenuItem", "headerMenuItem")}
                        onClick={() => (window.location = "/workflows")}
                        disabled={!checkRole(user, ROLES.ELEVATED)}
                    >
                        Workflows
                    </MenuItem>
                </Menu>

                <IconButton
                    aria-haspopup="true"
                    color="inherit"
                    aria-controls="profile-menu"
                    onClick={(e) => setProfileMenu(e.currentTarget)}
                    sx={{ marginRight: "1em" }}
                >
                    <Person className="headerIcon" />
                </IconButton>
                <Menu
                    id="profile-menu"
                    open={Boolean(profileMenu)}
                    anchorEl={profileMenu}
                    onClose={() => setProfileMenu(null)}
                    className="headerMenu"
                    classes={{ paper: "profileMenu" }}
                    disableAutoFocusItem
                >
                    <Typography variant="subtitle1" className="profileMenuUserName">
                        {user.name}
                    </Typography>
                    <hr />
                    <MenuItem className={classNames("profileMenuItem", "headerMenuItem")}>
                        <Settings className="profileMenuIcon" /> Settings
                    </MenuItem>
                    {checkRole(user, [ROLES.ADMIN]) && (
                        <MenuItem
                            className={classNames("profileMenuItem", "headerMenuItem")}
                            onClick={() => (window.location = "/admin")}
                        >
                            <AdminPanelSettings className="profileMenuIcon" /> Admin
                        </MenuItem>
                    )}
                    <MenuItem className={classNames("profileMenuItem", "headerMenuItem")}>
                        <RoleImpersonation />
                    </MenuItem>
                    <MenuItem
                        className={classNames("profileMenuItem", "headerMenuItem")}
                        onClick={() => logout()}
                    >
                        <Logout className="profileMenuIcon" /> Logout
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Header;